import { useState } from 'react'
import GenerateProposalModal from './GenerateProposalModal'
import OffersModal from './OffersModal'
import ListDocumentsModal from './ListDocumentsModal'
import PersonalInfo from './PersonalInfo'
import { useCrefazContext } from '@/app/contexts/CrefazContext'
import { useRegisterSupportContext } from '@/app/store/supportScreenContext'
import { PartnerType } from '@/app/utils/partners.enum'

const STEP_LABEL = {
  generate: 'Geração de proposta Crefaz',
  offers: 'Ofertas Crefaz',
  listDocuments: 'Documentos Crefaz',
  PersonalInfo: 'Dados pessoais Crefaz',
}

interface CrefazModalProps {
  onBack: () => void
  onClose?: () => void
}

export default function CrefazModal({ onBack, onClose }: CrefazModalProps) {
  const [step, setStep] = useState<
    'generate' | 'offers' | 'listDocuments' | 'PersonalInfo'
  >('generate')
  const { customerData, proposalData, transactionId } = useCrefazContext()

  useRegisterSupportContext('simulation.crefaz', {
    product: PartnerType.CREFAZ,
    step: STEP_LABEL[step],
    transactionId: transactionId ?? undefined,
    data: { customer: customerData, proposal: proposalData },
  })

  if (step === 'generate') {
    return (
      <GenerateProposalModal
        onBack={onBack}
        onContinue={() => setStep('offers')}
      />
    )
  }

  if (step === 'offers') {
    return (
      <OffersModal
        onBack={() => setStep('generate')}
        onContinue={() => setStep('listDocuments')}
      />
    )
  }

  if (step === 'listDocuments') {
    return (
      <ListDocumentsModal
        onBack={() => setStep('offers')}
        onContinue={() => setStep('PersonalInfo')}
      />
    )
  }

  if (step === 'PersonalInfo') {
    return (
      <PersonalInfo
        onBack={() => setStep('listDocuments')}
        onFinish={onClose || onBack}
      />
    )
  }

  return null
}
